// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Directive, Input, Output, EventEmitter, HostListener, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Directive({
    selector: '[appThrottleClick]',
    standalone: false
})
export class ThrottleClickDirective implements OnInit {
  @Input() throttleTime = 200;
  @Output() throttleClick = new EventEmitter();
  private clicks = new Subject();

  ngOnInit() {
    this.clicks.pipe(
      throttleTime(this.throttleTime),
      untilDestroyed(this)
    ).subscribe(e => this.throttleClick.emit(e));
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
